import { render } from "./ListeGroupeTaxePage.vue?vue&type=template&id=dd0fe0ee&ts=true"
import script from "./ListeGroupeTaxePage.vue?vue&type=script&lang=ts"
export * from "./ListeGroupeTaxePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__